export const PO_STATUS = {
    draft: ["Draft", "bg-slate-100 text-slate-700"],
    sent: ["Sent", "bg-blue-100 text-blue-800"],
    received: ["Received", "bg-emerald-100 text-emerald-800"],
    closed: ["Closed", "bg-slate-800 text-white"],
    cancelled: ["Cancelled", "bg-rose-100 text-rose-700"],
};

export const POStatusPill = ({ status, tid }) => {
    const [label, cls] = PO_STATUS[status] || PO_STATUS.draft;
    return <span className={`px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider ${cls}`} data-testid={tid}>{label}</span>;
};

export const PAYMENT_PRESETS = ["Prepaid", "Payment on Delivery"];
